import { IDocs } from '_core/types';
import { checkUpdateMemberStatusApi as API } from '../Apis';
import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';

export const CheckUpdateMemberStatusDocs: IDocs = {
  title: 'CheckUpdateMemberStatus',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.checkUpdateMemberStatus',
};

const prepareCall = () => API.call.get();

export const CheckUpdateMemberStatusMachine = GenericMachine(prepareCall, {
  docs: CheckUpdateMemberStatusDocs,
  definitions: API.definitions,
});
